import React from 'react';
import classNames from 'classnames';
import {
  Typography, Alert
} from '@one-thd/sui-atomic-components';

const RefreshDrawerInfo = () => {
  const infoDrawerClass = classNames(
    'sui-grid',
    'sui-grid-cols-1',
    'sui-gap-1',
    'sui-justify-items-start',
    'sui-pr-8',
    'sui-bg-primary',
    'sui-shrink',
    'sui-basis-auto',
    'sui-grow'
  );

  const pricingInfoMessage = `Pricing, discounts and markdowns, and item availability
  may change. Some items or pricing options may no longer be available after refreshing a quote.`;

  const saveOldQuoteMessage = (
    <>
      <Typography weight="bold">Need to save your old quote details?</Typography>
      <Typography data-testid="beforeRefreshQuote-info">
        Print, email or save a copy of the expired quote for your records before refreshing a quote.
      </Typography>
      <div className="sui-pt-2">
        <Typography>
          Are you sure you want to refresh this quote?
        </Typography>
      </div>
    </>
  );

  return (
    <div className={infoDrawerClass} data-testid="refreshQuote-info">
      <Alert
        status="warning"
        data-testid="refreshQuote-pricing-info-alert"
      >
        <Typography>
          {pricingInfoMessage}
        </Typography>
      </Alert>
      {saveOldQuoteMessage}
    </div>
  );
};

export { RefreshDrawerInfo };
